// src/store/index.js

import Vue from 'vue'
import Vuex from 'vuex'

import keyModule from './modules/key';
import messageModule from './modules/messages';
import imageCacherModule from './modules/imageCacher';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        key: keyModule,
        globalMessages: messageModule,
        imC: imageCacherModule
    }
})
